// src/components/Intranet/Components/comunicacion/GestorDocumentos.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../../../../api";
import { ENDPOINTS } from "../../Utils/Endpoints";
import { getSessionUserId, isSessionSuperAdmin, getSessionEmpresaId } from "../../../../utils/SessionUser";
import AlertDialog from "../../../Lms/Components/Shared/AlertDialog";
import "../../Styles/index.css";
import sigmaDelete from "../../../Pages/img/Borrar.png";
import ConfirmDeleteDialog from "../../../security/ConfirmDeleteDialog";

const UPLOAD_ENDPOINT = `${API_BASE}/upload/documento`;
const DELETE_PHRASE = "ELIMINAR";
const SERVER_URL = API_BASE.replace(/\/api\/?$/, ''); // Base URL for images

const GestorDocumentos = ({ onNavigate }) => {
    // Estado de datos
    const [allAreas, setAllAreas] = useState([]); // Todas las areas (Sidebar / Checklist)
    const [managedAreas, setManagedAreas] = useState([]); // Areas que gestiono (Sender)
    const [allGestorRelations, setAllGestorRelations] = useState([]); // Relación Empleado-Area para mostrar "Publicado por"
    const [allEmployees, setAllEmployees] = useState([]);
    const [allPersonas, setAllPersonas] = useState([]);

    const [selectedArea, setSelectedArea] = useState(null); // Area activa en sidebar
    const [documentos, setDocumentos] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [currentEmpleadoId, setCurrentEmpleadoId] = useState(null);
    const [empresasList, setEmpresasList] = useState([]);
    const [empresaFiltroId, setEmpresaFiltroId] = useState(getSessionEmpresaId()?.toString() || "todas");

    // Estado del modal/forms
    const [showModal, setShowModal] = useState(false);
    const [currentDoc, setCurrentDoc] = useState(null); // Para editar/eliminar

    const [form, setForm] = useState({
        titulo: "",
        archivo: null,
        areasSeleccionadas: [], // Visibility
        idAreaRemitente: 0 // Sender Area
    });

    const [archivoPreview, setArchivoPreview] = useState(null); // Blob URL or name
    const [error, setError] = useState("");
    const [dragActive, setDragActive] = useState(false);

    // Estado para AlertDialog
    const [alertConfig, setAlertConfig] = useState({
        open: false,
        title: "",
        message: "",
        variant: "info"
    });

    // Estado para error de título duplicado
    const [tituloError, setTituloError] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [fileTouched, setFileTouched] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    // Carga inicial y "User Mapping Waltz"
    useEffect(() => {
        const init = async () => {
            setLoading(true);
            try {
                const userId = getSessionUserId();
                console.log("[GestorDocumentos] UserId from Session:", userId);

                const [resUsers, resDummyPersonas, resEmpleados, resGestor, rAreas] = await Promise.all([
                    axios.get(ENDPOINTS.usuarios),
                    axios.get(ENDPOINTS.personas),
                    axios.get(ENDPOINTS.empleados),
                    axios.get(ENDPOINTS.gestorDocumental),
                    axios.get(ENDPOINTS.areasNegocios)
                ]);

                const rawAreas = rAreas.data || [];
                const isSuper = isSessionSuperAdmin();
                const myEmpresaId = getSessionEmpresaId();

                let validEmpresaIds = [Number(myEmpresaId)];
                let loadedEmpresas = [{ idEmpresa: Number(myEmpresaId), nombre: "Mi Empresa (Propia)" }];
                
                if (!isSuper) {
                    try {
                        const resDesc = await axios.get(ENDPOINTS.empresasDescendientes(myEmpresaId));
                        const descendientes = resDesc.data || [];
                        const descIds = descendientes.map(d => Number(d.idEmpresa || d.IdEmpresa));
                        validEmpresaIds = [...validEmpresaIds, ...descIds];
                        
                        descendientes.forEach(d => {
                             const nombreCorto = d.nombre || d.Nombre || `Empresa Hija ${d.idEmpresa || d.IdEmpresa}`;
                             const nombrePadre = d.nombrePadre || d.NombrePadre;
                             const nombreLargo = nombrePadre ? `${nombreCorto} (hija de ${nombrePadre})` : nombreCorto;

                             loadedEmpresas.push({
                                  idEmpresa: Number(d.idEmpresa || d.IdEmpresa),
                                  nombre: nombreLargo
                             });
                        });
                    } catch (e) {
                        console.warn("No se pudieron cargar empresas descendientes", e);
                    }
                }
                
                setEmpresasList(loadedEmpresas);

                const filteredAreas = rawAreas.filter(a => {
                    if (isSuper) return true;
                    const empId = a.idEmpresa || a.IdEmpresa;
                    return validEmpresaIds.includes(Number(empId)) || !empId || Number(empId) === 0;
                });

                // Todas las areas para el sidebar
                setAllAreas(filteredAreas);
                setAllGestorRelations(resGestor.data);
                setAllEmployees(resEmpleados.data);
                setAllPersonas(resDummyPersonas.data);

                console.log("[GestorDocumentos] Raw Gestor Relations:", resGestor.data);
                console.log("[GestorDocumentos] All Areas:", filteredAreas);

                console.log("[GestorDocumentos] UserId type:", typeof userId);
                if (resUsers.data.length > 0) {
                    console.log("[GestorDocumentos] Sample User Obj:", resUsers.data[0]);
                }

                // User Mapping - Handle casing and type
                const myUser = resUsers.data.find(u => (u.idUsuario || u.IdUsuario) == userId);
                console.log("[GestorDocumentos] Found User:", myUser);

                if (!myUser) {
                    setError("No se encontro el usuario en el sistema.");
                    setLoading(false);
                    return;
                }

                const myPersonaId = myUser.idPersona || myUser.IdPersona;
                const myEmpleado = resEmpleados.data.find(e => (e.idPersona || e.IdPersona) === myPersonaId);
                console.log("[GestorDocumentos] Found Empleado:", myEmpleado);

                if (!myEmpleado) {
                    setError("Tu usuario no tiene un perfil de empleado asociado.");
                    setLoading(false);
                    return;
                }

                const empId = myEmpleado.idEmpleado || myEmpleado.IdEmpleado;
                setCurrentEmpleadoId(empId);

                // Identify Managed Areas
                const misPermisos = resGestor.data.filter(g => (g.idEmpleado || g.IdEmpleado) === empId && (g.activo || g.Activo));
                console.log("[GestorDocumentos] Raw Permisos for Empleado:", misPermisos);

                const misAreaIds = misPermisos.map(p => p.idAreaNegocio || p.IdAreaNegocio);
                const misAreas = filteredAreas.filter(a => misAreaIds.includes(a.idAreaNegocio || a.IdAreaNegocio));
                console.log("[GestorDocumentos] Calculated Managed Areas:", misAreas);

                setManagedAreas(misAreas);

                // Default selection logic: Prioritize managed areas, then current company, then first available
                let defaultArea = null;
                if (misAreas.length > 0) {
                    defaultArea = misAreas[0];
                } else if (filteredAreas.length > 0) {
                    // Try to find an area matching current company
                    defaultArea = filteredAreas.find(a => 
                        Number(a.idEmpresa || a.IdEmpresa) === Number(myEmpresaId)
                    ) || filteredAreas[0];
                }

                if (defaultArea) {
                    setSelectedArea(defaultArea);
                }

                setLoading(false);

            } catch (err) {
                console.error("Error inicializando gestor:", err);
                setError("Error al cargar configuración de permisos.");
                setLoading(false);
            }
        };

        if (ENDPOINTS.gestorDocumental) {
            init();
        } else {
            setError("Falta configuración de ENDPOINTS.");
            setLoading(false);
        }

    }, []);

    // Cargar documentos cuando cambia el área seleccionada
    useEffect(() => {
        if (!selectedArea) return;

        const loadDocs = async () => {
            try {
                const userId = getSessionUserId();
                const selectedAreaId = selectedArea.idAreaNegocio || selectedArea.IdAreaNegocio;

                // En comunicación usamos el endpoint general pero filtramos por área en el servidor
                const resDocs = await axios.get(ENDPOINTS.documentos, {
                    params: {
                        idUsuario: userId,
                        idAreaNegocio: selectedAreaId,
                        activo: true
                    }
                });

                setDocumentos(resDocs.data);

            } catch (err) {
                console.error("Error cargando documentos:", err);
            }
        };

        loadDocs();
    }, [selectedArea]);

    const handleAreaClick = (area) => {
        const currentId = selectedArea?.idAreaNegocio || selectedArea?.IdAreaNegocio;
        const targetId = area.idAreaNegocio || area.IdAreaNegocio;

        // Si ya está seleccionada la misma área, no hacer nada
        if (currentId === targetId) {
            return;
        }
        setSelectedArea(area);
        setDocumentos([]);
    };

    const handleOpenNew = () => {
        setForm({
            titulo: "",
            archivo: null,
            areasSeleccionadas: [],
            idAreaRemitente: selectedArea ? selectedArea.idAreaNegocio : (allAreas.length > 0 ? allAreas[0].idAreaNegocio : 0)
        });
        setArchivoPreview(null);
        setCurrentDoc(null);
        setShowModal(true);
    };

    const handleOpenEdit = async (doc) => {
        setCurrentDoc(doc);

        let areasIds = [];
        try {
            const currentDocId = doc.idDocumento || doc.IdDocumento;
            const res = await axios.get(ENDPOINTS.documentoArea);
            const relaciones = res.data.filter(da => (da.idDocumento || da.IdDocumento) === currentDocId && (da.activo || da.Activo));
            areasIds = relaciones.map(da => da.idAreaNegocio || da.IdAreaNegocio);
        } catch (error) {
            console.error("Error cargando áreas:", error);
        }

        const docUrl = doc.urlDocumento || doc.UrlDocumento || "";
        const formTitulo = doc.titulo || doc.Titulo || (docUrl ? docUrl.split('/').pop() : "Documento");

        setForm({
            titulo: formTitulo,
            archivo: null,
            areasSeleccionadas: areasIds,
            idAreaRemitente: doc.idAreaNegocio || doc.IdAreaNegocio || (selectedArea ? (selectedArea.idAreaNegocio || selectedArea.IdAreaNegocio) : 0)
        });
        setArchivoPreview(null);
        setShowModal(true);
    };

    // --- Rich File Upload Handlers ---
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFileSelection(e.dataTransfer.files[0]);
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            handleFileSelection(e.target.files[0]);
        }
    };

    const handleFileSelection = (file) => {
        // Validar que solo sean archivos permitidos (PDF, DOCX, PPTX)
        const allowedExtensions = ['.pdf', '.doc', '.docx', '.ppt', '.pptx'];
        const fileName = file.name.toLowerCase();
        const isAllowed = allowedExtensions.some(ext => fileName.endsWith(ext));

        if (!isAllowed) {
            setFileTouched(true);
            // ... reset file?
            setForm(prev => ({ ...prev, archivo: null }));
            setArchivoPreview(null);
            setShowModal(false); // Cerrar el modal primero
            setTimeout(() => {
                setAlertConfig({
                    open: true,
                    title: "Tipo de archivo no permitido",
                    message: "Solo se permiten archivos PDF, Word (DOC/DOCX) y PowerPoint (PPT/PPTX). No se permiten imágenes ni otros tipos de archivo.",
                    variant: "warning"
                });
            }, 100);
            return;
        }

        setForm(prev => ({ ...prev, archivo: file }));
        setArchivoPreview(null); // No preview para documentos
    };
    // ----------------------

    const handleToggleArea = (areaId) => {
        setForm(prev => {
            const exists = prev.areasSeleccionadas.includes(areaId);
            if (exists) {
                return { ...prev, areasSeleccionadas: prev.areasSeleccionadas.filter(id => id !== areaId) };
            } else {
                return { ...prev, areasSeleccionadas: [...prev.areasSeleccionadas, areaId] };
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsSaving(true);
            // --- VALIDACIONES PREVIAS (Para evitar subir basura al S3) ---

            // Validar título duplicado
            try {
                const resDocs = await axios.get(ENDPOINTS.documentos);
                const allDocs = resDocs.data.filter(d => d.activo);

                // Si es nuevo documento, verificar que el título no exista
                // Si es edición, verificar que el título no exista en OTROS documentos
                const tituloLower = form.titulo.trim().toLowerCase();
                const duplicado = allDocs.find(d =>
                    d.titulo.toLowerCase() === tituloLower &&
                    (!currentDoc || d.idDocumento !== currentDoc.idDocumento)
                );

                if (duplicado) {
                    setTituloError(`Ya existe un documento con el título "${form.titulo}".`);
                    setIsSaving(false);
                    return;
                }

                // Limpiar error si no hay duplicado
                setTituloError("");
            } catch (err) {
                console.error("Error validando título:", err);
            }

            if (!currentDoc) {
                // Nuevo Documento
                if (form.areasSeleccionadas.length === 0) {
                    setIsSaving(false);
                    setAlertConfig({
                        open: true,
                        title: "Falta información",
                        message: "Debes seleccionar al menos un área de visibilidad (Checklist).",
                        variant: "warning"
                    });
                    return;
                }
                if (!form.idAreaRemitente) {
                    setIsSaving(false);
                    setAlertConfig({
                        open: true,
                        title: "Falta información",
                        message: "Debes seleccionar el Área Remitente.",
                        variant: "warning"
                    });
                    return;
                }
                if (!form.archivo) {
                    setIsSaving(false);
                    setAlertConfig({
                        open: true,
                        title: "Falta archivo",
                        message: "Debes seleccionar un archivo para subir.",
                        variant: "warning"
                    });
                    return;
                }
            }
            // -------------------------------------------------------------

            let finalUrl = currentDoc ? (currentDoc.urlDocumento || currentDoc.UrlDocumento) : "";

            // 1. Subir archivo
            if (form.archivo) {
                // Si es edición y ya había un documento, eliminar el anterior del S3
                const delUrl = currentDoc ? (currentDoc.urlDocumento || currentDoc.UrlDocumento) : null;
                if (currentDoc && delUrl) {
                    try {
                        await axios.delete(UPLOAD_ENDPOINT, { params: { filePath: delUrl } });
                        console.log("Documento anterior eliminado del S3:", delUrl);
                    } catch (err) {
                        console.error("Advertencia al borrar anterior S3:", err);
                    }
                }

                const formData = new FormData();
                formData.append('file', form.archivo);
                const resUpload = await axios.post(UPLOAD_ENDPOINT, formData);
                console.log("Respuesta de subida:", resUpload.data);
                finalUrl = resUpload.data.filePath || resUpload.data;
            }

            if (currentDoc) {
                const currentDocId = currentDoc.idDocumento || currentDoc.IdDocumento;
                // UPDATE
                const payload = {
                    idDocumento: currentDocId,
                    urlDocumento: finalUrl,
                    idEmpleadoGestor: currentDoc.idEmpleadoGestor || currentDoc.IdEmpleadoGestor,
                    idAreaNegocio: form.idAreaRemitente || currentDoc.idAreaNegocio || currentDoc.IdAreaNegocio,
                    activo: true,
                    titulo: form.titulo
                };
                await axios.put(ENDPOINTS.documentos, payload);

                // Sync Areas
                const resDA = await axios.get(ENDPOINTS.documentoArea);
                const currentRelations = resDA.data.filter(da => (da.idDocumento || da.IdDocumento) === currentDocId && (da.activo || da.Activo));
                const currentIds = currentRelations.map(da => da.idAreaNegocio || da.IdAreaNegocio);
                const targetIds = new Set(form.areasSeleccionadas);

                // Add
                const toAdd = form.areasSeleccionadas.filter(id => !currentIds.includes(id));
                for (const id of toAdd) {
                    await axios.post(ENDPOINTS.documentoArea, {
                        idDocumentoArea: 0,
                        idDocumento: currentDocId,
                        idAreaNegocio: id,
                        activo: true
                    });
                }

                // Remove
                const toRemove = currentRelations.filter(da => !targetIds.has(da.idAreaNegocio || da.IdAreaNegocio));
                for (const rel of toRemove) {
                    await axios.put(ENDPOINTS.documentoArea, { ...rel, activo: false, Activo: false });
                }

                setShowModal(false);
                setTimeout(() => {
                    setAlertConfig({
                        open: true,
                        title: "Documento actualizado",
                        message: "El documento se ha actualizado correctamente.",
                        variant: "success"
                    });
                }, 100);

            } else {
                // CREATE
                // Insert Document
                const payloadDoc = {
                    idDocumento: 0,
                    urlDocumento: finalUrl,
                    idEmpleadoGestor: currentEmpleadoId,
                    titulo: form.titulo,
                    idAreaNegocio: form.idAreaRemitente,
                    activo: true,
                    fecha: new Date().toISOString(),
                    idEmpresa: getSessionEmpresaId()
                };
                const resDoc = await axios.post(ENDPOINTS.documentos, payloadDoc);
                const newDocId = resDoc.data;

                // Insert Visibility Links
                const allTargetAreas = new Set([...form.areasSeleccionadas]);

                for (const areaId of allTargetAreas) {
                    const payloadArea = {
                        idDocumentoArea: 0,
                        idDocumento: newDocId,
                        idAreaNegocio: areaId,
                        activo: true
                    };
                    await axios.post(ENDPOINTS.documentoArea, payloadArea);
                }

                setShowModal(false);
                setTimeout(() => {
                    setAlertConfig({
                        open: true,
                        title: "Documento publicado",
                        message: "El documento se ha publicado exitosamente.",
                        variant: "success"
                    });
                }, 100);
            }

            // setShowModal(false); // Eliminado o comentado, ya se hace arriba con timeout
            const temp = selectedArea;
            setSelectedArea(null);
            setTimeout(() => setSelectedArea(temp), 50);
            setIsSaving(false);
        } catch (err) {
            console.error("Error guardando documento:", err);
            setIsSaving(false);
            setShowModal(false);
        }
    };

    const handleDelete = async () => {
        if (!currentDoc) return;

        try {
            const currentDocUrl = currentDoc.urlDocumento || currentDoc.UrlDocumento;
            const currentDocId = currentDoc.idDocumento || currentDoc.IdDocumento;
            // Eliminar archivo físico de S3
            if (currentDocUrl) {
                console.log("Intentando borrar de S3:", currentDocUrl);
                await axios.delete(UPLOAD_ENDPOINT, { params: { filePath: currentDocUrl } });
            }
            // Eliminar registro de BD
            await axios.delete(`${ENDPOINTS.documentos}/${currentDocId}`);
            setShowModal(false);
            setAlertConfig({
                open: true,
                title: "Documento eliminado",
                message: "El documento ha sido eliminado correctamente.",
                variant: "success"
            });
            const temp = selectedArea;
            setSelectedArea(null);
            setTimeout(() => setSelectedArea(temp), 50);
        } catch (err) {
            console.error("No se pudo eliminar el documento: ", err);
        }
    };

    const formatFecha = (f) => {
        if (!f) return "";
        const date = new Date(f);
        return isNaN(date.getTime()) ? "" : date.toLocaleDateString();
    };

    // --- RENDER ---

    if (loading) return <div className="intra-loading">Cargando permisos...</div>;
    if (error) return <div className="intra-error-panel">{error}</div>;

    const isImagePreview = form.archivo && form.archivo.type.startsWith('image/');

    // Check if current doc is image (from URL extension)
    const isCurrentDocImage = currentDoc && currentDoc.urlDocumento && (currentDoc.urlDocumento.endsWith('.png') || currentDoc.urlDocumento.endsWith('.jpg') || currentDoc.urlDocumento.endsWith('.jpeg') || currentDoc.urlDocumento.endsWith('.webp'));

    return (
        <div className="intra-docs-page">
            <header className="intra-docs-header">
                <div>
                    <h1 className="intra-docs-title">Gestión Documental</h1>
                    <p className="intra-docs-subtitle">
                        Repositorio centralizado de documentos por áreas de negocio.
                    </p>
                </div>
                {onNavigate && (
                    <button className="intra-button-ghost btn-cancel" onClick={() => onNavigate("dashboard")}>
                        ← Volver al dashboard
                    </button>
                )}
            </header>

            <section className="intra-docs-layout">

                {/* SIDEBAR: TODAS LAS AREAS (Contactos) */}
                <aside className="intra-docs-users-panel">
                    <h2 className="intra-docs-panel-title">Áreas de Negocio</h2>
                    <p className="intra-docs-panel-subtitle">Explora documentos por área.</p>

                    {empresasList.length > 1 && (
                        <div style={{ marginBottom: '1rem' }}>
                            <select
                                className="intra-input"
                                value={empresaFiltroId}
                                onChange={(e) => setEmpresaFiltroId(e.target.value)}
                                style={{ width: '100%', fontSize: '0.85rem', padding: '0.5rem', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                            >
                                <option value="todas">Todas las empresas</option>
                                {empresasList.map(emp => (
                                    <option key={emp.idEmpresa} value={emp.idEmpresa}>{emp.nombre}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="intra-docs-users-list">
                        {allAreas.filter(area => {
                            if (empresaFiltroId === "todas") return true;
                            const empId = area.idEmpresa || area.IdEmpresa;
                            return Number(empId) === Number(empresaFiltroId);
                        }).map((area, idx) => {
                            const areaId = area.idAreaNegocio || area.IdAreaNegocio;
                            const currentId = selectedArea ? (selectedArea.idAreaNegocio || selectedArea.IdAreaNegocio) : null;
                            const isSelected = areaId === currentId;

                            return (
                                <div
                                    key={areaId || idx}
                                    className={`intra-docs-user-row ${isSelected ? 'intra-docs-user-row--selected' : ''}`}
                                    onClick={() => handleAreaClick(area)}
                                >
                                    <span className="intra-docs-user-name">
                                        {area.nombre || area.Nombre || area.descripcion || area.Descripcion}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </aside>

                {/* MAIN: DOCUMENTOS */}
                <main className="intra-docs-main-panel">
                    <div className="intra-docs-main-header">
                        <div className="intra-docs-main-left">
                            <span className="intra-docs-main-title">
                                {selectedArea ? `${selectedArea.nombre || selectedArea.Nombre || selectedArea.descripcion}` : 'Selecciona un área'}
                            </span>
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            {selectedArea && (
                                <input
                                    type="text"
                                    placeholder="Buscar por título o autor..."
                                    value={searchTerm}
                                    onChange={e => setSearchTerm(e.target.value)}
                                    style={{
                                        padding: '0.5rem 1rem',
                                        borderRadius: '20px',
                                        border: '1px solid #cbd5e1',
                                        outline: 'none',
                                        width: '250px',
                                        fontSize: '0.85rem'
                                    }}
                                />
                            )}
                            <button className="btn-action" onClick={handleOpenNew} title="Subir Documento">
                                Subir
                            </button>
                        </div>
                    </div>

                    <div className="intra-docs-docs-grid">
                        {documentos.filter(doc => {
                            if (!searchTerm) return true;
                            const term = searchTerm.toLowerCase();
                            const title = (doc.titulo || doc.Titulo || "").toLowerCase();

                            // Resolver autor
                            const docIdGestor = doc.idEmpleadoGestor || doc.IdEmpleadoGestor;
                            let authorName = (doc.gestorNombre || doc.GestorNombre || "").toLowerCase();
                            if (!authorName) {
                                // Buscar de relaciones si DTO no lo trajo
                                const rel = allGestorRelations.find(r => r.idEmpleadoGestor === docIdGestor && r.idAreaNegocio === doc.idAreaNegocio && r.activo);
                                if (rel && rel.empleado) {
                                    const pf = rel.empleado.persona;
                                    authorName = pf ? `${pf.nombre || ''} ${pf.apellidoPaterno || ''}`.trim().toLowerCase() : '';
                                } else {
                                    // Fallback profundo
                                    const emp = allEmployees.find(e => (e.idEmpleado || e.IdEmpleado) === docIdGestor);
                                    const pers = emp ? allPersonas.find(p => (p.idPersona || p.IdPersona) === (emp.idPersona || emp.IdPersona)) : null;
                                    if (pers) {
                                        authorName = (pers.nombreCompleto || pers.NombreCompleto || `${pers.nombre || pers.Nombre} ${pers.apellidoPaterno || pers.ApellidoPaterno}`).toLowerCase();
                                    }
                                }
                            }

                            return title.includes(term) || (authorName && authorName.includes(term));
                        }).map(doc => {
                            const esOrigen = doc.esOrigen ?? doc.EsOrigen ?? false;
                            // Evaluación de propiedad: El usuario es el creador O tiene permisos sobre el área remitente O es origen (multitenant) O superadmin
                            const isMine = ((doc.idEmpleadoGestor || doc.IdEmpleadoGestor) === currentEmpleadoId)
                                || managedAreas.some(ma => (ma.idAreaNegocio || ma.IdAreaNegocio) === (doc.idAreaNegocio || doc.IdAreaNegocio))
                                || esOrigen
                                || isSessionSuperAdmin();

                            return (
                                <article
                                    key={doc.idDocumento || doc.IdDocumento}
                                    className={`intra-docs-doc-card ${isMine ? 'intra-docs-doc-card--mine' : ''}`}
                                    onClick={() => {
                                        const docUrl = doc.urlDocumento || doc.UrlDocumento;
                                        if (docUrl) {
                                            window.open(docUrl.startsWith('http') ? docUrl : `${SERVER_URL}${docUrl}`, '_blank');
                                        }
                                    }}
                                    style={{ cursor: 'pointer', position: 'relative' }}
                                >
                                    {(() => {
                                        const docIdGestor = doc.idEmpleadoGestor || doc.IdEmpleadoGestor;

                                        // 1. Prioridad: Si el DTO ya trae el nombre (frecuente en algunas vistas)
                                        if (doc.gestorNombre || doc.GestorNombre) return (
                                            <div style={{ fontSize: '0.7rem', color: '#64748b', marginBottom: '0.6rem', fontStyle: 'italic' }}>
                                                Por: {doc.gestorNombre || doc.GestorNombre}
                                            </div>
                                        );

                                        // 2. Fallback: Buscar en los estados cargados
                                        const emp = allEmployees.find(e => (e.idEmpleado || e.IdEmpleado) === docIdGestor);
                                        const pers = emp ? allPersonas.find(p => (p.idPersona || p.IdPersona) === (emp.idPersona || emp.IdPersona)) : null;

                                        if (pers) {
                                            // Concatena de forma segura: Nombre + Paterno + Materno
                                            const nombrePartes = [
                                                pers.nombre || pers.Nombre,
                                                pers.apellidoPaterno || pers.ApellidoPaterno,
                                                pers.apellidoMaterno || pers.ApellidoMaterno
                                            ].filter(part => part && part !== "undefined");

                                            let nombre = pers.nombreCompleto || pers.NombreCompleto;
                                            if (!nombre || nombre === "undefined undefined") {
                                                nombre = nombrePartes.join(" ").trim();
                                            }

                                            if (nombre && nombre.length > 2) {
                                                return (
                                                    <div style={{ fontSize: '0.7rem', color: '#64748b', marginBottom: '0.6rem', fontStyle: 'italic' }}>
                                                        Por: {nombre}
                                                    </div>
                                                );
                                            }
                                        }
                                        return null;
                                    })()}

                                    <h3 className="intra-docs-doc-title">
                                        {((doc.titulo || doc.Titulo) && (doc.titulo || doc.Titulo).trim() !== "" && (doc.titulo || doc.Titulo) !== "Sin Título")
                                            ? (doc.titulo || doc.Titulo)
                                            : (doc.fechaFormateada || formatFecha(doc.fecha || doc.Fecha))}
                                    </h3>

                                    <div className="intra-docs-doc-footer">
                                        {/* Mostrar la fecha siempre en el footer si hay un título real */}
                                        {((doc.titulo || doc.Titulo) && (doc.titulo || doc.Titulo).trim() !== "" && (doc.titulo || doc.Titulo) !== "Sin Título")
                                            ? <span>{formatFecha(doc.fecha || doc.Fecha)}</span>
                                            : <span></span>}

                                        {/* Link de Editar alineado a la derecha, SOLO si es mío */}
                                        {isMine ? (
                                            <span
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleOpenEdit(doc);
                                                }}
                                                className="intra-docs-doc-edit-link"
                                                style={{ color: 'var(--color-primary)', cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}
                                            >
                                                Editar
                                            </span>
                                        ) : (
                                            <span></span>
                                        )}
                                    </div>
                                </article>
                            )
                        })}

                        {documentos.length === 0 && selectedArea && (
                            <div className="intra-docs-empty">No hay documentos visibles en esta área.</div>
                        )}
                    </div>
                </main>
            </section>

            {/* MODAL */}
            {showModal && (
                <div className="intra-modal-backdrop" onClick={() => !isSaving && setShowModal(false)}>
                    <div className="intra-modal" onClick={e => e.stopPropagation()}>
                        <div className="intra-modal-header">
                            <h2 className="intra-modal-title">{currentDoc ? "Editar Documento" : "Nuevo Documento"}</h2>
                            <button className="intra-modal-close" onClick={() => !isSaving && setShowModal(false)} style={{ opacity: isSaving ? 0.3 : 1, cursor: isSaving ? 'default' : 'pointer' }}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="intra-modal-body">

                                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                                    {/* Título */}
                                    <div className="intra-form-group" style={{ flex: 1 }}>
                                        <label className="intra-label">Título del Documento</label>
                                        <input
                                            type="text"
                                            className="intra-input"
                                            value={form.titulo}
                                            onChange={e => {
                                                setForm({ ...form, titulo: e.target.value });
                                                setTituloError(""); // Limpiar error al escribir
                                            }}
                                            onBlur={async () => {
                                                // Validar título duplicado cuando el usuario sale del campo
                                                if (!form.titulo.trim()) return;

                                                try {
                                                    const resDocs = await axios.get(ENDPOINTS.documentos);
                                                    const allDocs = resDocs.data.filter(d => d.activo);

                                                    const tituloLower = form.titulo.trim().toLowerCase();
                                                    const duplicado = allDocs.find(d =>
                                                        d.titulo.toLowerCase() === tituloLower &&
                                                        (!currentDoc || d.idDocumento !== currentDoc.idDocumento)
                                                    );

                                                    if (duplicado) {
                                                        setTituloError(`Ya existe un documento con el título "${form.titulo}".`);
                                                    } else {
                                                        setTituloError("");
                                                    }
                                                } catch (err) {
                                                    console.error("Error validando título:", err);
                                                }
                                            }}
                                            required
                                            placeholder="Ej. Manual de Procesos 2024"
                                            disabled={isSaving}
                                        />
                                        {tituloError && (
                                            <small style={{ color: '#b91c1c', display: 'block', marginTop: '0.25rem' }}>{tituloError}</small>
                                        )}
                                    </div>

                                    {/* Área Remitente (Solo Nuevo) */}
                                    {!currentDoc && (
                                        <div className="intra-form-group" style={{ width: '30%', minWidth: '200px' }}>
                                            <label className="intra-label" title="Área desde la que publicas">Enviado desde:</label>
                                            <select
                                                className="intra-input"
                                                value={form.idAreaRemitente}
                                                onChange={e => setForm({ ...form, idAreaRemitente: Number(e.target.value) })}
                                                required
                                                disabled={isSaving}
                                            >
                                                <option value={0}>-- Área --</option>
                                                {managedAreas.map((a, idx) => (
                                                    <option key={a.idAreaNegocio || a.IdAreaNegocio || idx} value={a.idAreaNegocio || a.IdAreaNegocio}>{a.nombre || a.Nombre || a.descripcion}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>

                                {/* Archivo (Rich UI) */}
                                <div className="intra-form-group">
                                    <label className="intra-label">Documento Adjunto</label>
                                    <div
                                        className={`file-uploader${(form.archivo || currentDoc) ? ' file-uploader--filled' : ''}${dragActive ? ' file-uploader--uploading' : ''}`}
                                        onDragEnter={handleDrag}
                                        onDragLeave={handleDrag}
                                        onDragOver={handleDrag}
                                        onDrop={handleDrop}
                                        style={{ pointerEvents: isSaving ? 'none' : 'auto', opacity: isSaving ? 0.6 : 1 }}
                                    >
                                        {(form.archivo || currentDoc) && (
                                            <div className="file-uploader__badge">
                                                <span>✓</span>
                                                <span>{form.archivo ? 'Archivo seleccionado' : 'Archivo actual'}</span>
                                            </div>
                                        )}

                                        {(form.archivo || currentDoc) && (
                                            <div className="file-uploader__preview" style={{ flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                                                {((isImagePreview && archivoPreview) || (currentDoc && !form.archivo && isCurrentDocImage)) ? (
                                                    <img
                                                        src={form.archivo ? archivoPreview : ((currentDoc.urlDocumento || currentDoc.UrlDocumento || '').startsWith('http') ? (currentDoc.urlDocumento || currentDoc.UrlDocumento) : `${SERVER_URL}${(currentDoc.urlDocumento || currentDoc.UrlDocumento)}`)}
                                                        alt="Preview"
                                                        style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '6px', objectFit: 'contain' }}
                                                    />
                                                ) : (
                                                    <div style={{ fontSize: '3.5rem', lineHeight: 1 }}>
                                                        {(() => {
                                                            const name = form.archivo ? form.archivo.name : (currentDoc.urlDocumento || currentDoc.UrlDocumento || "");
                                                            const ext = name ? name.split('.').pop().toLowerCase() : "";
                                                            if (ext === 'pdf') return '📕';
                                                            if (['doc', 'docx'].includes(ext)) return '📘';
                                                            if (['xls', 'xlsx', 'csv'].includes(ext)) return '📗';
                                                            if (['ppt', 'pptx'].includes(ext)) return '📙';
                                                            if (['zip', 'rar', '7z'].includes(ext)) return '🗂️';
                                                            if (['txt', 'md'].includes(ext)) return '📝';
                                                            return '📎';
                                                        })()}
                                                    </div>
                                                )}
                                                <div style={{ color: '#334155', fontWeight: 600, wordBreak: 'break-all' }}>
                                                    {form.archivo ? form.archivo.name : (currentDoc.urlDocumento || currentDoc.UrlDocumento || "").split('/').pop()}
                                                </div>
                                            </div>
                                        )}

                                        <label className="file-uploader__label">
                                            <input
                                                type="file"
                                                accept=".pdf,.doc,.docx,.ppt,.pptx"
                                                onClick={(e) => { e.target.value = ''; }}
                                                onChange={handleFileChange}
                                            />
                                            <span className="file-uploader__icon">{(form.archivo || currentDoc) ? '🔄' : '☁️'}</span>
                                            <span className="file-uploader__text">{(form.archivo || currentDoc) ? 'Cambiar archivo' : 'Haz clic para subir archivo'}</span>
                                            <span className="file-uploader__hint">PDF, Word (DOC/DOCX), PowerPoint (PPT/PPTX) - Máx 10MB</span>
                                        </label>
                                    </div>
                                    {fileTouched && !form.archivo && !currentDoc && (
                                        <small style={{ color: '#b91c1c', display: 'block', marginTop: '0.4rem' }}>Documento es obligatorio</small>
                                    )}
                                </div>

                                {/* Checklist (Grid 2 cols, Scroll) */}
                                <div className="intra-form-group">
                                    <label className="intra-label">Visible para (Checklist):</label>
                                    <div style={{
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        border: '1px solid #e2e8f0',
                                        padding: '0.8rem',
                                        borderRadius: '6px',
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr',
                                        gap: '0.5rem',
                                        alignContent: 'start'
                                    }}>
                                        {allAreas.filter(area => {
                                            if (empresaFiltroId === "todas") return true;
                                            const empId = area.idEmpresa || area.IdEmpresa;
                                            return Number(empId) === Number(empresaFiltroId);
                                        }).map(area => {
                                            const aid = area.idAreaNegocio || area.IdAreaNegocio;
                                            return (
                                                <div key={aid} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', cursor: 'pointer', width: '100%', fontSize: '0.9rem' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={form.areasSeleccionadas.includes(aid)}
                                                            onChange={() => handleToggleArea(aid)}
                                                            style={{ width: '16px', height: '16px', accentColor: '#2563eb' }}
                                                            disabled={isSaving}
                                                        />
                                                        {area.nombre || area.Nombre || area.descripcion || area.Descripcion}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                            </div>
                            <div className="intra-modal-footer">
                                {currentDoc && (
                                    <button
                                        type="button"
                                        className="rk-iconbtn rk-iconbtn--del"
                                        onClick={() => setDeleteOpen(true)}
                                        disabled={isSaving}
                                        style={{ opacity: isSaving ? 0.5 : 1, cursor: isSaving ? 'default' : 'pointer', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0px' }}
                                        title="Eliminar"
                                    >
                                        <img src={sigmaDelete} alt="Eliminar" className="rk-ico" style={{ width: '40px', height: '40px' }} />
                                    </button>
                                )}
                                <div style={{ flex: 1 }}></div>
                                <button
                                    type="button"
                                    className="btn-cancel"
                                    onClick={() => setShowModal(false)}
                                    disabled={isSaving}
                                    style={{ opacity: isSaving ? 0.5 : 1, cursor: isSaving ? 'default' : 'pointer' }}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn-action"
                                    disabled={isSaving || !form.titulo.trim() || form.areasSeleccionadas.length === 0 || (!currentDoc && !form.archivo) || !!tituloError}
                                    style={{
                                        opacity: (isSaving || !form.titulo.trim() || form.areasSeleccionadas.length === 0 || (!currentDoc && !form.archivo) || !!tituloError) ? 0.6 : 1,
                                        cursor: (isSaving || !form.titulo.trim() || form.areasSeleccionadas.length === 0 || (!currentDoc && !form.archivo) || !!tituloError) ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {isSaving ? "Guardando..." : "Guardar"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* AlertDialog */}
            <AlertDialog
                open={alertConfig.open}
                onClose={() => setAlertConfig(prev => ({ ...prev, open: false }))}
                title={alertConfig.title}
                message={alertConfig.message}
                variant={alertConfig.variant}
            />

            <ConfirmDeleteDialog
                open={deleteOpen}
                roleName={currentDoc?.titulo || currentDoc?.Titulo || "este documento"}
                onClose={() => setDeleteOpen(false)}
                onConfirm={() => {
                    setDeleteOpen(false);
                    handleDelete();
                }}
            />
        </div >
    );
};

export default GestorDocumentos;
